// src/components/ui/PrimaryButton.jsx

export default function PrimaryButton({ href, children, target = "_self" }) {
  return (
    <a
      href={href}
      target={target}
      rel={target === "_blank" ? "noreferrer" : undefined}
      className="btn btn--primary"
    >
      {children}
    </a>
  );
}
